import { formatPrice } from '~/src/utils/formatPrice'

export const convertData = (data: any) => {
  return {
    data: data?.items.map((item: any) => {
      return {
        id: item?.id?.toString() ?? '0',
        contactNo: item.id,
        refNo: item.refNo ?? '-',
        controlNo: item.refNo ?? '-',
        nameProduct: item.name ?? '-',
        categoryName: item.productName ?? '-',
        orderDetail: item.orderDetail ? item.orderDetail.replace(/\n/, "<br>") : '',
        status: item?.status ?? '-',
        supplyType: item.supplyType ?? '',
        manufacture: item.maker ?? '-',
        nameCar: item.name ?? '-',
        modelVehicle: item.modelCode ?? '-',
        year: item.year ?? '-',
        originalRefNo: item.originalRefNo || '-',
        originalRemark: item.originalRemark,
        price: formatPrice(item.type, Number(item.price), item.isUnacquiredPrice),
        finalPrice: Number(item.finalPrice) ? `${Number(item.finalPrice).toLocaleString(undefined, { maximumFractionDigits: 8 })}` : '',
        isDeposited: item.user.isDeposited,
        createDate: item.createdAt ?? 0,
        updateDate: item.updatedAt ?? 0,
        companyName: item.user.companyName ?? '-',
        isUnread: item.isUnread,
      }
    }),
    users: data?.items.map((item: any) => {
      return {
        id: item?.id?.toString() ?? '0',
        user: item?.user,
      }
    }),
    pagination: {
      currentPage: data.pagination.currentPage ?? 0,
      limitValue: data.pagination.limitValue ?? 0,
      totalCount: data.pagination.totalCount ?? 0,
      totalPages: data.pagination.totalPages ?? 0,
    },
  }
}
